import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minToTime'
})
export class MinToTimePipe implements PipeTransform {

  transform(minutes: number, duration?: number, type?: number): any {
    if (minutes > 1439) minutes -= 1440
    var time=""
    if (type == 1) time = "Rest "
    if (type == 2) time = "Bowl "
    time += this.numpad(Math.floor(minutes/60)) + ":" + this.numpad(minutes - (Math.floor(minutes/60)*60));
    if (duration) {
      var minutes2 = minutes + duration
      if (minutes2 > 1439) minutes2 -= 1440
      //time += " - " + Math.floor((minutes2)/60).toString().padStart(2, '0') + ":" + this.numpad((minutes2) - (Math.floor((minutes2)/60)*60));
      time += " - " + Math.floor((minutes2)/60).toString() + ":" + this.numpad((minutes2) - (Math.floor((minutes2)/60)*60));
    }
    return time;
  }

  private numpad(d) {
    let p = '0';
    if (d > 9) p = '';
    return p + d;
  }


}
